import Carousel from '@carvana/ds-carousel';
import { useState } from 'react';
import useWhyBuyData from '~/hooks/vdp/selectors/useWhyBuyData';
import useCarouselAnalytics from '~/hooks/vdp/useCarouselAnalytics';
import { isDefined } from '~/utilities/array';
import WhyBuyCarouselCard from './WhyBuyCarouselCard';

export default function WhyBuyCarousel() {
  const { bulletPoints = [] } = useWhyBuyData();
  const showCarousel = isDefined(bulletPoints) && bulletPoints.length > 0;
  const handleAnalytics = useCarouselAnalytics();

  const [isClamped, setIsClamped] = useState(true);

  return showCarousel ? (
    <Carousel
      classes={{
        arrows: 'md:flex md:gap-lg',
        pagination: 'overflow-hidden',
        slide:
          'pl-lg first:pl-2xl last:pr-2xl md:pl-0 md:first:pl-0 md:last:pr-0',
        slides: 'gap-0 md:gap-xl pb-[2px]',
        topSection: 'px-2xl gap-0 md:px-0 md:grid-cols-[1fr_auto]',
        wrapper: 'overflow-visible md:px-4xl'
      }}
      ariaLabel="features you'll love"
      data-testid="why-buy-carousel"
      headerContent={<div />}
      hideScrollBar
      slideByVisible
      trackEvent={event => {
        handleAnalytics({ event });
      }}
    >
      {bulletPoints?.map(bulletPoint => {
        return bulletPoint.title && bulletPoint.content ? (
          <WhyBuyCarouselCard
            key={bulletPoint.title}
            bulletPoint={bulletPoint}
            isClamped={isClamped}
            setIsClamped={setIsClamped}
          />
        ) : null;
      })}
    </Carousel>
  ) : null;
}
